module.exports = {
      id: "fb-whitebg-usage",
      viewBox: "0 0 24 24",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#fb-whitebg",
      toString: function () {
        return this.url;
      }
    }